import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { FormSectionRenderer } from 'components/form/SectionRenderer';

const Form = ({ sectionConfigs, formData, handleSubmit, setFormData, isSubmitLoading, title }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const keyParts = name?.split('.') ?? [];

    setFormData((prev) => {
      const newState = { ...prev };
      let current = newState;

      // Handle all parts except the last one
      for (let i = 0; i < keyParts?.length - 1; i++) {
        const key = keyParts?.[i];

        current[key] = { ...current[key] };
        current = current[key];
      }

      // Set the value at the last key
      const lastKey = keyParts?.[keyParts?.length - 1];

      current[lastKey] = value;

      return newState;
    });
  };

  return (
    <>
      {title && (
        <Text fontSize='2xl' fontWeight='bold' mb={6}>
          {title}
        </Text>
      )}
      <form onSubmit={handleSubmit}>
        <VStack spacing={6} align='stretch'>
          {sectionConfigs.map((section) => (
            <FormSectionRenderer key={section.title} {...section} formData={formData} onChange={handleInputChange} />
          ))}
          <Box display='flex' justifyContent='flex-end'>
            <Button type='submit' colorScheme='blue' size='lg' isLoading={isSubmitLoading}>
              Submit
            </Button>
          </Box>
        </VStack>
      </form>
    </>
  );
};

export default Form;
